var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.padless ? '' : 'bordered-section',
    _vm.$vuetify.rtl ? 'bordered-right' : 'bordered-left',
    ("bordered-section" + _vm.sectionNumber),
    _vm.mainSection ? 'bordered-top' : '',
    _vm.thickBorder
      ? _vm.$vuetify.rtl
        ? 'bordered-right-thick'
        : 'bordered-left-thick'
      : ''
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }